import PropTypes from 'prop-types';

export const imageType = PropTypes.shape({
  data: PropTypes.string,
  height: PropTypes.number,
  url: PropTypes.string.isRequired,
  webpUrl: PropTypes.string,
  width: PropTypes.number.isRequired,
});

export const responsiveImageAlternativeType = PropTypes.shape({
  aspect: PropTypes.number,
  blur: imageType,
  sizes: PropTypes.arrayOf(imageType),
});

export const responsiveImageType = PropTypes.shape({
  alt: PropTypes.string,
  aspect: PropTypes.number,
  blur: imageType,
  copyright: PropTypes.string,
  sizes: PropTypes.arrayOf(imageType),
  alternatives: PropTypes.objectOf(responsiveImageAlternativeType),
});
